// extracted by mini-css-extract-plugin
module.exports = {"title":"author-poll_title__3emYx","tab-list":"author-poll_tab-list__2L2G9","tab":"author-poll_tab__tnwlp","tab--selected":"author-poll_tab--selected__Rhaba"};